import { defineComponent, inject, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { clubRepositoryKey } from '@/staff/domain/club/ClubRepository';
import { fromClub } from '@/staff/primary/club/Club.ui';
import { DropdownVue } from '@/common/primary/dropdown';
import { DropdownItemVue } from '@/common/primary/dropdown/dropdown-item';
import { DropdownSeparatorVue } from '@/common/primary/dropdown/dropdown-separator';
import { ExclusiveUi } from '@/staff/primary/exclusive/Exclusive.ui';

export default defineComponent({
  name: 'AuctionExclusiveRow',

  props: {
    exclusive: {
      type: Object as PropType<ExclusiveUi>,
      required: true,
    },
    index: {
      type: Number as PropType<number>,
      required: true,
    },
  },

  components: { DropdownVue, DropdownSeparatorVue, DropdownItemVue },

  setup() {
    const { t } = useI18n();
    const clubRepository = inject(clubRepositoryKey)!;

    const club = fromClub(clubRepository.getCurrentClub());

    return {
      club,
      t,
    };
  },
});
